import { Component, Input } from '@angular/core';
import { ModalController, NavController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { TournamentService } from '../../../services/tournament.service';
import { SportAlgoUtils } from '../../../services/sport.algo';
import { EditMeKoPage } from '../../edits/me-ko/me-ko-edit';

/**
 * Spielpaarung
 * Interface for plan
 */

@Component({
  selector: 'result-me-ko',
  templateUrl: 'result-me-ko.html',
})
export class ResultMeKoPage {
  gamePlanList: IGamePlan[] = [];
  tab: string = 'overview';
  roundPhaseBtn = false;

  @Input() activePlan: any = 0;
  @Input() header: boolean = true;

  constructor(
    private navCtrl: NavController,
    private navParams: NavParams,
    private modalCtrl: ModalController,
    public gs: TournamentService,
    private toastCtrl: ToastController,
    private viewCtrl:ViewController
  ) {
    this.activePlan = this.navParams.get('activePlan') || this.activePlan;
    SportAlgoUtils.createRoundTeamsTable(this.gs.planList[this.activePlan]);
  }

  onEditTeam(teamIndex: any) {
    let modal = this.modalCtrl.create(EditMeKoPage, { activePlan: this.activePlan, teamIndex: teamIndex, roundPhase: this.gs.planList[this.activePlan].roundPhase });
    modal.present();
    modal.onDidDismiss(() => {
      if (!this.gs.planList[this.activePlan].roundPhase) this.isRoundPhaseReady();
      this.sortTeams();
      // if(this.plan.roundPhase){
      //   this.createRoundGameTable();
      // }
    });
  }
  dismiss(option) {
    this.viewCtrl.dismiss(option);
  }

  message() {
    this.toastCtrl.create({
      message: 'All teams should play',
      duration: 3000
    });
  }

  isRoundPhaseReady() {
    let check = false;
    for (let r = 0; r < this.gs.planList[this.activePlan].rounds; r++) {
      for (let i = 0; i < this.gs.planList[this.activePlan].gameTable[r].length; i++) {
        for (let j = 0; j < this.gs.planList[this.activePlan].gameTable[r][i].length; j++) {
          if (!this.gs.planList[this.activePlan].gameTable[r][i][j].played) {
            check = true;
          }
        }
      }
    }
    this.roundPhaseBtn = !check;
  }

  onRoundPhaseStart() {
    this.gs.planList[this.activePlan].roundPhase = true;
    this.roundPhaseBtn = false;
    this.createRoundGameTable();
    this.tab = 'map';

  }

  createRoundGameTable() {
    this.sortTeams();
    this.transform();
    this.gs.save();
    this.gs.saveTou(this.gs.planList[this.activePlan]).then(plan => {
      this.gs.planList[this.activePlan] = plan;
    })
  }

  transform() {
    // this.gs.planList[this.activePlan].roundGameTable[0] = this.matchAlgorithm();
  }

  sortTeams() {
    if(!this.gs.planList[this.activePlan].roundTeams){
      SportAlgoUtils.createRoundTeamsTable(this.gs.planList[this.activePlan]);
    };

    for (let i = 0; i < this.gs.planList[this.activePlan].roundTeams.length; i++) {
      this.gs.planList[this.activePlan].roundTeams[i].sort((a, b) => b.points - a.points);
    }
  }

  // n - number of groups
  // function returns the appropriate size of the matrix
  getMatrixSize(n: number) {
    if(n > 85) console.warn('The matrix size is too large...');

    if (n <= 1) {
      return 1;
    } else if (n <= 2) {
      return 2;
    } else if (n <= 5) {
      return 4;
    } else if (n <= 10){
      return 8;
    } else if (n <= 21){
      return 16;
    } else if (n <= 42){
      return 32;
    } else {
      return 64;
    }
  }

  matchRecursive(n: number): number {
    if (n <= 1) {
      return this.rounds.length;
    } else {
      this.rounds.push(n);
      return this.matchRecursive(n / 2);
    }
  }

  rounds = [];
  matchAlgorithm() {
    // the first day - start
    let N = Number(this.gs.planList[this.activePlan].groupNum);
    let id = 0;
    let arr = [];
    for (let i = 0; i < N - 1; i++) {
      let add = [];
      for (let j = 0; j < this.gs.planList[this.activePlan].roundTeams[i].length - 1; j += 2) {
        let gamePlan = {
          id: new Date().getTime() + id,
          type: this.gs.planList[this.activePlan].plantype,
          gameDay: i,
          name: this.gs.planList[this.activePlan].name,
          winner: -1,
          played: false,
          results: "0-0",
          mapping: true,
          points: "0-0",
          team1: {
            result: 0,
            points: 0,
            id: this.gs.planList[this.activePlan].roundTeams[i][j + 1].id,
            name: this.gs.planList[this.activePlan].roundTeams[i][j + 1].name
          },
          team2: {
            result: 0,
            points: 0,
            id: this.gs.planList[this.activePlan].roundTeams[i + 1][j].id,
            name: this.gs.planList[this.activePlan].roundTeams[i + 1][j].name
          }
        }

        arr.push(gamePlan);

        if (i == 0) {
          let addGamePlan = {
            id: new Date().getTime() + id,
            type: this.gs.planList[this.activePlan].plantype,
            gameDay: i,
            name: this.gs.planList[this.activePlan].name,
            winner: -1,
            played: false,
            mapping: true,
            results: "0-0",
            points: "0-0",
            team1: {
              result: 0,
              points: 0,
              id: this.gs.planList[this.activePlan].roundTeams[i][j].id,
              name: this.gs.planList[this.activePlan].roundTeams[i][j].name
            },
            team2: {
              result: 0,
              points: 0,
              id: this.gs.planList[this.activePlan].roundTeams[N - 1][j + 1].id,
              name: this.gs.planList[this.activePlan].roundTeams[N - 1][j + 1].name
            }
          };
          add.push(addGamePlan);
          if (j + 1 >= this.gs.planList[this.activePlan].roundTeams[i].length - 1) {
            for (let k = 0; k < add.length; k++) {
              arr.push(add[k]);
            }
          }
        }
        id += 1;
      }
    }

    return arr;
  }
}

export interface IGamePlan {
  id: number;
  gameDay: number;
  name: string;
  team1: {
    id: number;
    name: string;
  };
  team2: {
    id: number;
    name: string;
  }
}


// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/results/result-me-ko/result-me-ko.ts